import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

const StackedBarChart = ({ dataChart }) => {
  // Define initial state for timeDiffs and dateLabels
  const [timeDiffs, setTimeDiffs] = useState([]);
  const [dateLabels, setDateLabels] = useState([]);

  useEffect(() => {
    const calculateTimeDiffsAndDates = () => {
      const extractedDateLabels = [];
      const dateData = {};

      if (dataChart && dataChart.length > 0) {
        dataChart.forEach((item) => {
          const caseTime = item.historyTime ? new Date(item.historyTime).toLocaleString() : '';
          const reportTime = item.reportTime ? new Date(item.reportTime).toLocaleString() : '';

          const caseDate = moment(caseTime, 'MM/DD/YYYY, h:mm:ss a');
          const currentTime = moment(reportTime, 'MM/DD/YYYY, h:mm:ss a');

          const diff = currentTime.diff(caseDate, 'hours');
          const dateLabel = item.date.split(',')[0];

          if (!dateData[dateLabel]) {
            dateData[dateLabel] = {
              dateLabel,
              green: 0,
              yellow: 0,
              orange: 0,
              red: 0,
            };
            extractedDateLabels.push(dateLabel);
          }

          if (diff < 1) {
            dateData[dateLabel].green += 1;
          } else if (diff >= 1 && diff < 2) {
            dateData[dateLabel].yellow += 1;
          } else if (diff >= 2 && diff < 3) {
            dateData[dateLabel].orange += 1;
          } else if (diff >= 3 && diff < 4) {
            dateData[dateLabel].red += 1;
          }
        });

        const timeDiffsArray = extractedDateLabels.map((dateLabel) => ({
          dateLabel,
          green: dateData[dateLabel].green,
          yellow: dateData[dateLabel].yellow,
          orange: dateData[dateLabel].orange,
          red: dateData[dateLabel].red,
        }));

        setTimeDiffs(timeDiffsArray);
        setDateLabels(extractedDateLabels);
      }
    };

    calculateTimeDiffsAndDates();
  }, [dataChart]);

  // Define the data for the stacked bar chart
  const data = {
    labels: dateLabels, // Use extracted date labels as chart labels
    datasets: [
      {
        maxBarThickness: 40,
        label: 'Green',
        backgroundColor: 'green',
        data: timeDiffs.map((data) => data.green),
      },
      {
        maxBarThickness: 40,
        label: 'Yellow',
        backgroundColor: 'yellow',
        data: timeDiffs.map((data) => data.yellow),
      },
      {
        maxBarThickness: 40,
        label: 'Orange',
        backgroundColor: 'orange',
        data: timeDiffs.map((data) => data.orange),
      },
      {
        maxBarThickness: 40,
        label: 'Red',
        backgroundColor: 'red',
        data: timeDiffs.map((data) => data.red),
      },
    ],
  };

  const options = {
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: true,
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default StackedBarChart;
